export const appConfig = {
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:3000/api/v1',
  appName: 'EasyAta',
  tagline: 'Simplificando o registro. Preservando a história.',
  version: '1.2.0',
  gaMeasurementId: 'G-R6H18YKLMT',
  developer: {
    name: '3LA Labs',
    url: 'https://www.3lalabs.com.br',
    tagline: 'Presença digital sob medida para empresas que querem transmitir confiança.',
    about:
      'A 3LA Labs é uma empresa de desenvolvimento digital focada em criar sites e landing pages profissionais, rápidos e alinhados ao negócio de cada cliente.',
    services: [
      'Sites institucionais sob medida',
      'Landing pages de conversão',
      'Design responsivo e moderno',
      'Performance, SEO e manutenção',
    ],
  },
  author: {
    name: 'Ir∴ Luan Cesar Santos Barbosa - CIM: 333.893',
    lodge:
      'A∴ R∴ L∴ S∴ Fraternidade, Caminho e Luz, nº 3.216 - Oriente de São Sebastião do Paraíso - MG',
    role: 'Fundador da 3LA Labs e criador do EasyAta',
    about:
      'Mestre Maçom, esposo da Aline e pai de duas lindas filhas Liz e Luiza. Desenvolvedor de software apaixonado por transformar o dia a dia das Lojas com ferramentas simples e úteis. Criou o EasyAta para ajudar Secretários e Irmãos a redigirem atas com mais agilidade, padronização e fraternidade — de Irmão para Irmãos.',
  },
  donation: {
    enabled: import.meta.env.VITE_DONATION_ENABLED !== 'false',
    pixKey: import.meta.env.VITE_DONATION_PIX_KEY || '3lalabs@3lalabs.com.br',
    pixKeyType: import.meta.env.VITE_DONATION_PIX_KEY_TYPE || 'E-mail',
    recipientName: import.meta.env.VITE_DONATION_RECIPIENT_NAME || 'Ir∴ Luan Cesar Santos Barbosa',
    bannerMessage:
      import.meta.env.VITE_DONATION_BANNER_MESSAGE ||
      'Feito de Irmão para Irmãos — se o EasyAta tem sido útil na sua Loja, considere apoiar este trabalho fraterno.',
    message:
      import.meta.env.VITE_DONATION_MESSAGE ||
      'Este projeto nasceu do desejo de um Irmão ajudar outros Irmãos na redação das atas. Qualquer contribuição ajuda a manter o EasyAta disponível para todas as Lojas — totalmente voluntária e opcional.',
  },
};
